export default __webpack_public_path__ + "static/media/wildcard-logo-horz-tagline-reverse-cr.2175cabb.png";